import { Form } from "antd";
import {
  drinking,
  orphan,
  selectBodyHeight,
  selectBodyWeight,
  smoking,
} from "../helper";
import Select from "components/BaseWidgets/select";
import RadioButton from "components/BaseWidgets/radioButton";
import "./style.scss";
import { useSelectOptions } from "hooks/api/useListing";

function PhysicalMaritalDetails({ form }) {
  // select apis
  const {
    maritalStatus,
    familyStatus,
    bodyType,
    complexion,
    diet,
    physicalStatus,
  } = useSelectOptions();

  return (
    <div className="about-bride-wrapper physical-marital-wrapper  flex flex-col items-center w-full">
      <div className="heading-wrapper w-full flex flex-col gap-2 mb-8">
        <p className="title font-title-xl">
          Family, physical, and marital details
        </p>
        <p className="sub-text font-body-md2">
          Tell us about the appearance and marital status.
        </p>
      </div>
      <div className="basic-info-wrapper w-full mb-6">
        <div className="bride-form-container">
          <Form
            form={form}
            className="basic-form"
            layout="vertical"
            initialValues={{
              is_orphan: "false",
              drink: 2,
              smoke: 2,
            }}
          >
            <Form.Item
              name="marital_status"
              className="form-item m-0"
              rules={[
                {
                  required: true,
                  message: "Please select your marital status",
                },
              ]}
            >
              <Select
                widthVariant="wFull"
                placeholder="Select"
                labelClassName={`label`}
                inputClassName={`select-dropdown`}
                label="Marital status"
                options={maritalStatus?.options}
                isLoading={maritalStatus?.isLoading}
              />
            </Form.Item>

            <Form.Item
              name="family_status"
              className="form-item m-0"
              rules={[
                {
                  required: true,
                  message: "Please select your family status",
                },
              ]}
            >
              <Select
                widthVariant="wFull"
                placeholder="Select"
                labelClassName={`label`}
                inputClassName={`select-dropdown`}
                label="Family status"
                options={familyStatus?.options}
                isLoading={familyStatus?.isLoading}
              />
            </Form.Item>

            <Form.Item
              name="height"
              className="form-item m-0"
              rules={[
                {
                  required: true,
                  message: "Please select your body height",
                },
              ]}
            >
              <Select
                widthVariant="wFull"
                placeholder="Select"
                labelClassName={`label`}
                inputClassName={`select-dropdown`}
                label="Body height"
                options={selectBodyHeight}
              />
            </Form.Item>

            <Form.Item
              name="weight"
              className="form-item m-0"
              rules={[
                {
                  required: true,
                  message: "Please select your body weight",
                },
              ]}
            >
              <Select
                widthVariant="wFull"
                placeholder="Select"
                labelClassName={`label`}
                inputClassName={`select-dropdown`}
                label="Body weight"
                options={selectBodyWeight}
              />
            </Form.Item>

            <Form.Item
              name="body_type"
              className="form-item m-0"
              rules={[
                {
                  required: true,
                  message: "Please select your body type",
                },
              ]}
            >
              <Select
                widthVariant="wFull"
                placeholder="Select"
                labelClassName={`label`}
                inputClassName={`select-dropdown`}
                label="Body type"
                options={bodyType?.options}
                isLoading={bodyType?.isLoading}
              />
            </Form.Item>

            <Form.Item
              name="complexion"
              className="form-item m-0"
              rules={[
                {
                  required: true,
                  message: "Please select your complexion",
                },
              ]}
            >
              <Select
                widthVariant="wFull"
                placeholder="Select"
                labelClassName={`label`}
                inputClassName={`select-dropdown`}
                label="Complexion"
                options={complexion?.options}
                isLoading={complexion?.isLoading}
              />
            </Form.Item>

            <Form.Item
              name="diet"
              className="form-item m-0"
              rules={[
                {
                  required: true,
                  message: "Please select your diet",
                },
              ]}
            >
              <Select
                widthVariant="wFull"
                placeholder="Select"
                labelClassName={`label`}
                inputClassName={`select-dropdown`}
                label="Diet"
                options={diet?.options}
                isLoading={diet?.isLoading}
              />
            </Form.Item>

            <Form.Item
              name="physical_status"
              className="form-item m-0"
              rules={[
                {
                  required: true,
                  message: "Please mention any physical challenges",
                },
              ]}
            >
              <Select
                widthVariant="wFull"
                placeholder="Select"
                labelClassName={`label`}
                inputClassName={`select-dropdown`}
                label="Mention any physical challenges"
                options={physicalStatus?.options}
                isLoading={physicalStatus?.isLoading}
                onChange={(value) => {
                  form.setFieldsValue({
                    physicalChallenge: value,
                  });
                }}
              />
            </Form.Item>

            <div className="radio-button-wrapper w-full flex flex-col">
              <div className="radio-button-container flex flex-col gap-3">
                <label className="input-label">Are you an orphan?</label>
                <Form.Item
                  name="is_orphan"
                  rules={[
                    {
                      required: true,
                      message: "Please select an option for isOrphan",
                    },
                  ]}
                >
                  <RadioButton
                    className="radio-button-label"
                    radioGroupClass="radio-group"
                    options={orphan}
                    variant="secondary"
                  />
                </Form.Item>
              </div>

              <div className="radio-button-container flex flex-col gap-3">
                <label className="input-label">Drinking</label>
                <Form.Item
                  name="drink"
                  rules={[
                    {
                      required: true,
                      message: "Please select an option for drinking",
                    },
                  ]}
                >
                  <RadioButton
                    className="radio-button-label"
                    radioGroupClass="radio-group"
                    options={drinking}
                    variant="secondary"
                  />
                </Form.Item>
              </div>

              <div className="radio-button-container flex flex-col gap-3">
                <label className="input-label">Smoking</label>
                <Form.Item
                  name="smoke"
                  rules={[
                    {
                      required: true,
                      message: "Please select an option for smoking",
                    },
                  ]}
                >
                  <RadioButton
                    className="radio-button-label"
                    radioGroupClass="radio-group"
                    options={smoking}
                    variant="secondary"
                  />
                </Form.Item>
              </div>
            </div>
          </Form>
        </div>
      </div>
    </div>
  );
}

export default PhysicalMaritalDetails;
